import omitBy from 'lodash/omitBy';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import queryString from 'query-string';
import { push } from 'connected-react-router';
import { getQueryString } from 'store/router/routerSelectors';
import queryValuesToString from './queryValuesToString';

export default ({ state, newQuery, dispatch }) => {
  const update = queryValuesToString(newQuery || {});
  const currentQuery = queryString.parse(getQueryString(state));
  const updatedQuery = omitBy({ ...currentQuery, ...update }, isEmpty);

  if (!isEqual(updatedQuery, currentQuery)) {
    const newQueryString = queryString.stringify({ ...updatedQuery });
    dispatch(push({ search: newQueryString }));
  }
};
